<template>
  <div>
    <q-card
      class="summaryStatsCard q-pa-sm text-center"
      :style="`background-color: ${bg}`"
      flat
      v-if="slides.length > 0"
    >
      <div class="row">
        <div
          class="col-12 text-bold"
          style="font-size: 11px; line-height: 13px"
        >
          {{ slides[currentSlide].cardTitle }}
        </div>
      </div>
      <div class="row items-center q-mt-sm">
        <div class="col-auto">
          <q-btn
            :disable="currentSlide == 0"
            @click="currentSlide -= 1"
            round
            dense
            flat
            icon="mdi-chevron-left"
          ></q-btn>
        </div>
        <div class="col">
          <div v-html="slides[currentSlide].cardMainContent"></div>
        </div>
        <div class="col-auto">
          <q-btn
            round
            dense
            flat
            icon="mdi-chevron-right"
            :disable="currentSlide == slides.length - 1"
            @click="currentSlide += 1"
          ></q-btn>
        </div>
      </div>
      <div class="row">
        <div
          class="col-12"
          style="font-size: 11px; font-style: italic; line-height: 13px"
        >
          <div v-html="slides[currentSlide].subContent"></div>
        </div>
        <div class="col-12">
          <p
            v-if="slides[currentSlide].action"
            :style="`font-size: 11px; ${
              slides[currentSlide].action.underlined
                ? 'text-decoration: underline;'
                : ''
            }`"
            class="text-right cursor-pointer"
            @click="$emit(slides[currentSlide].action.emit)"
          >
            {{ slides[currentSlide].action.label }}
          </p>
        </div>
      </div>
    </q-card>
  </div>
</template>

<script>
  export default {
    data: () => ({
      currentSlide: 0,
    }),
    props: {
      slides: {
        default: [],
      },
      bg: {
        type: String,
        default: "rgba(0, 0, 0, 0.27)",
      },
    },
    computed: {},
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .summaryStatsCard {
    color: white;
    width: 260px;
    height: 95px;

    h3 {
      font-size: 1.3rem;
      font-weight: 800;
    }
  }
</style>

